import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { Row, Col, Card } from "react-bootstrap"
import CTextBox from '../../../../Common/CTextBox';
import CDatePicker from '../../../../Common/CDatePicker';
import Message from '../../../../Common/Message';
import { Toggle } from '@fluentui/react/lib/Toggle';
import CTextArea from '../../../../Common/CTextArea';
import { useBoolean } from '@fluentui/react-hooks';
import List from '../../../../Templates/List';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import Picker from '../../../../Common/Picker';
import CValidator from '../../../../Common/CValidator';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { deleteMessage, saveMessageVisa, updateMessage } from "../../../../../services/sBook/message.service"
import { useGetMessageTopics, useGetSectionPartyFullsByBookId, useGetSectionsByPartyId } from "../../../../../hooks/services/sBook/useOfSection"
import { useAssignMessageToObject, useOfBookMessageComments } from '../../../../../hooks/services/sBook/useOfMessage';
import { useGetDocumentListByMessage } from '../../../../../hooks/services/sBook/useOfDocument';
import { ActionButton } from '@fluentui/react/lib/Button';
import { base64ToArrayBuffer, getKeyByValue, isNullUndefined, isNullUndefinedOrEmpty, joinWithoutDupes, saveByteArray, visibilityButtonBreakeVisa, visibilityButtonDelete, visibilityButtonSave, visibilityButtonSend, visibilityButtonSendToApprove } from '../../../../../common/Helpers';
import { __DocumentTypeKeys, enum__BOOK_SECTION_CLASS, enum__MessageStatus, enum__NOTIFICATION_INBOX_TYPE } from '../../../../../common/Dictionaries';
import { addListDocumentByMessage, downloadDocumentsByIds, removeDocumentByMessageDocument } from '../../../../../services/sBook/document.service';
import ListPagination from '../../../../Templates/List/ListPagination';
import DocumentLinkModal from '../../MessageTree/DocumentLinkModal';
import CTextAreaSimple from '../../../../Common/CTextAreaSimple';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../../common/CommonFuctions';
import { _global_buttonStyles } from '../../../../../common/ObjectStructures/Trasnversal';
import { ChoiceGroup, Dropdown, Pivot, PivotItem } from '@fluentui/react';
import { useInView } from '../../../../../common/IsInView';
import NotificationTasksCard from '../../../../../pages/sNotificationTasks/NotificationTaskCard';
import JqxGrid from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import SidePanelViewCommentEvent from '../../MessageEventsBox/SidePanelViewCommentEvent';
import { saveMessageComment } from '../../../../../services/sBook/message-log.service';
import { setNotificationCompleted } from '../../../../../services/sNotificationAlerts/notificationAlerts.service';
import './style.css'
import { cloneDeep, forEach } from 'lodash-es';
import { useGetDistributionGroupsMaintainer, useGetListUserDistributionGroup } from '../../../../../hooks/services/NotificationTask/useOfDistributionGroups';
import CLabel from '../../../../Common/CLabel';
import { useDispatch, useSelector } from 'react-redux';
import { action_setNotificacionTaskList, action_setNotificacionTaskListFiltred, action_setNotificacionTaskMenuItems } from '../../../../../reducers/actions/NotificationTasks/actions';
import { action_updateAlertList } from '../../../../../reducers/actions/SITE/actions';
import { action_updateEdPPrepareForceGetHeader } from '../../../../../reducers/actions/PAY/edpPrepareActions';
import Loading from '../../../../Templates/Site/Loading';
import DOMPurify from 'dompurify';
import SidePanelCreateWithTemplate from '../../MessageTree/SidePanelCreateWithTemplate';

function findPanelScroller(panelClassName) {
  // el Panel está en portal, así que buscamos en document
  const panelRoot = document.querySelector(`.${panelClassName}`);
  if (!panelRoot) return null;

  // contenedor típico que scrollea en Panel v8
  return panelRoot.querySelector(".ms-Panel-scrollableContent") || null;
}

function SidePanelEdit(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { 
        _notificationTaskDataList: notificationTaskDataList,
        _notificationTaskDataListFiltred: notificationTaskDataListFiltred,
        _notificationTaskMenuData: notificationTaskMenuData,
    } = useSelector((state) => state.notificationTaskState);

    const {
        _alertList: alertList,
    } = useSelector((state) => state.notificationAlertState);

    //inputParam_MessageObject Se usa para validar que valor tiene "visa" almacenado en la base. Si es 3, se asume que usuario guardó con sello roto.
    //en cambio si objMensaje solamente tiene "visa" en 3 y inputParam_MessageObject no, eso quiere decir que el sello está roto volatilmente.

    //Parametros de entrada.
    const inputParam_BookObject = props.bookObject !== null && props.bookObject !== undefined ? props.bookObject : null;
    const inputParam_MessageObject = props.messageObject !== null && props.messageObject !== undefined ? props.messageObject : null;
    const inputParam_UserProps = props.userProps !== null && props.userProps !== undefined ? props.userProps : null;
    const inputParam_CurrentUserName = props.currentUserName !== null && props.currentUserName !== undefined ? props.currentUserName : null;
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_SetterObjMessageList = props.setterObjMessageList !== null && props.setterObjMessageList !== undefined ? props.setterObjMessageList : null;
    const inputParam_SetterObjMessage = props.setterObjMessage !== null && props.setterObjMessage !== undefined ? props.setterObjMessage : null;
    const inputParam_SetterDocumentList = props.setterDocumentList !== null && props.setterDocumentList !== undefined ? props.setterDocumentList : null;
    const inputParam_NotificationMode = props.notificationMode !== null && props.notificationMode !== undefined ? props.notificationMode : false;
    const inputParam_NotificationTask = props.notificationTask !== null && props.notificationTask !== undefined ? props.notificationTask : null;
    const inputParam_ShowNotificationTask = props.showNotificationTask !== null && props.showNotificationTask !== undefined ? props.showNotificationTask : false;
    const inputParam_ForceShowComment = props.forceShowComment !== null && props.forceShowComment !== undefined ? props.forceShowComment : false;
    
    const inputParam_ParentEditMode = props.parentEditMode !== null && props.parentEditMode !== undefined ? props.parentEditMode : null;
    const inputParam_SettFireGetMessage = props.setFireGetMessage !== null && props.setFireGetMessage !== undefined ? props.setFireGetMessage : null;

    //Parametros de componente.
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [isDialogDeleteMessageVisible, { setTrue: showDeleteMessageDialog, setFalse: hideDeleteMessageDialog }] = useBoolean(false);
    const [isDialogBreakVisaMessageVisible, { setTrue: showBreakVisaMessageDialog, setFalse: hideBreakVisaMessageDialog }] = useBoolean(false);
    const [isPanelBreakVisaOpen, setIsPanelBreakVisaOpen] = useState(false);
    
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);

    const [itemToDelete, setItemToDelete] = useState(null);

    const [actionInProgress, setActionInProgress] = useState(false);
    
    const [isModalDocumentOpen, setIsModalDocumentOpen] = useState(false);
    const [isTemplatePanelOpen, setIsTemplatePanelOpen] = useState(false);

    const [txtNameIsInValid, setTxtNameIsInValid] = useState(false)
    const [txtCodeIsInValid, setTxtCodeIsInValid] = useState(false)
    const [txtBodyIsInValid, setTxtBodyIsInValid] = useState(false)
    const [pickerAnswerDeadlineDateIsInValid, setPickerAnswerDeadlineDateIsInValid] = useState(false)
    const [isInvalidSection, setIsInvalidSection] = useState(false);
    const [isInvalidSectionParty, setIsInvalidSectionParty] = useState(false);

    const [isInvalidDistributionGroupUserList, setIsInvalidDistributionGroupUserList] = useState(false);
    const [isInvalidDistributionGroupList, setIsInvalidDistributionGroupList] = useState(false);
    const [isInvalidVisaRejectedComment, setIsInvalidVisaRejectedComment] = useState(false);

    const [distributionGroupList, setDistributionGroupList] = useState(null);
    useGetDistributionGroupsMaintainer(distributionGroupList, setDistributionGroupList)


    const [objCommentToPanel, setObjCommentToPanel] = useState(null)
    const [isPanelObjCommentOpen, setIsPanelObjCommentOpen] = useState(false)
    
    const [notificationComment, setNotificationComment] = useState('')
    /*const [editMode, setEditMode] = useState(
        inputParam_ParentEditMode === false ? inputParam_ParentEditMode :
        (inputParam_NotificationMode === false ? (inputParam_MessageObject && (inputParam_MessageObject.visa === null || inputParam_MessageObject.visa === 3) ? true : false) : true)
    );*/

    const [editMode, setEditMode] = useState(
        inputParam_NotificationMode === true ? (inputParam_ParentEditMode === true && (inputParam_NotificationTask.completed === false || inputParam_NotificationTask.completed === null)) : (inputParam_MessageObject && (inputParam_MessageObject.visa === null || inputParam_MessageObject.visa === 2 || inputParam_MessageObject.visa === 3) ? (inputParam_ParentEditMode === true || inputParam_ParentEditMode === null) : (inputParam_MessageObject.visa === 2))
    );

    
    const [forceSetMessageObject, setForceSetMessageObject] = useState(false)

    const matchedSectionPartyForEdit = inputParam_MessageObject ? inputParam_UserProps.l_SectionPartyMemberHandler.find(x => x.sectionId === (inputParam_MessageObject.sectionId !== null ? inputParam_MessageObject.sectionId : null)) : undefined;

    const aux_messageObject = inputParam_MessageObject && {
        id: inputParam_MessageObject && inputParam_MessageObject.id,
        book_id: inputParam_MessageObject && inputParam_BookObject.id,
        section_id: inputParam_MessageObject && inputParam_MessageObject.sectionId,
        section_party_member_id: inputParam_UserProps.username !== null && inputParam_MessageObject.id !== null ? (matchedSectionPartyForEdit !== undefined ? matchedSectionPartyForEdit.sectionPartyMemberId : null) : null,
        section_party_from_id: inputParam_UserProps.username !== null && inputParam_MessageObject.id !== null ? (matchedSectionPartyForEdit !== undefined ? matchedSectionPartyForEdit.sectionPartyId : null) : null,
        item_message: { 
            id: inputParam_MessageObject && inputParam_MessageObject.id,
            sectionId: inputParam_MessageObject && inputParam_MessageObject.sectionId,
            messageNemo: inputParam_MessageObject && inputParam_MessageObject.messageNemo,
            messageCode: inputParam_MessageObject && inputParam_MessageObject.messageCode,
            correlative: inputParam_MessageObject && inputParam_MessageObject.correlative,
            title: inputParam_MessageObject && inputParam_MessageObject.title,
            body: inputParam_MessageObject && inputParam_MessageObject.body,
            topicId: inputParam_MessageObject && inputParam_MessageObject.topicId,
            messageTopicCode: inputParam_MessageObject && inputParam_MessageObject.messageTopicCode,
            senderUsername: inputParam_MessageObject && inputParam_MessageObject.senderUsername,
            sectionPartySenderId: inputParam_MessageObject && inputParam_MessageObject.sectionPartySenderId,
            sendDate: inputParam_MessageObject && inputParam_MessageObject.sendDate,//moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            answerNeeded: inputParam_MessageObject && inputParam_MessageObject.answerNeeded,
            answerToMessage: inputParam_MessageObject && inputParam_MessageObject.answerToMessage,
            answerMessageNemo: inputParam_MessageObject && inputParam_MessageObject.answerMessageNemo,
            answerMessageId: inputParam_MessageObject && inputParam_MessageObject.answerMessageId,
            answerDeadlineDate: inputParam_MessageObject && inputParam_MessageObject.answerDeadlineDate,
            attacheds: inputParam_MessageObject && inputParam_MessageObject.attacheds,
            deactivate: inputParam_MessageObject && inputParam_MessageObject.deactivate,
            /// <summary>
            /// 1 en preparación
            /// 2 en circulacion
            /// 3 en aprobacion
            /// 4 enviada  
            /// 5 enviada a visar      
            /// </summary>
            statusId: inputParam_MessageObject && inputParam_MessageObject.statusId,
            visa: inputParam_MessageObject && inputParam_MessageObject.visa,
        },
        l_section_party_to_ids:  inputParam_MessageObject.l_partys_to && inputParam_MessageObject.l_partys_to.map(a => a.sectionPartyId),
    };

    const [isInvalidTemplateSection, setIsInvalidTemplateSection] = useState(false);

    const [objMensaje, setObjMensaje] = useState(null);
    useAssignMessageToObject(objMensaje, aux_messageObject, setObjMensaje, inputParam_IsPanelOpen, forceSetMessageObject, setForceSetMessageObject);
    
    const [topicList, setTopicList] = useState(null);
    useGetMessageTopics(topicList, setTopicList, (!isNullUndefined(objMensaje) && !isNullUndefined(objMensaje.item_message)), (!isNullUndefined(objMensaje) && !isNullUndefined(objMensaje.item_message)) ? objMensaje.item_message.topicId : null);

    const documentUploadDisabled = objMensaje && objMensaje.item_message.id === null;

    const [distributionGroupUsersList, setDistributionGroupUsersList] = useState(
         inputParam_MessageObject.visa >= 0 &&
         !isNullUndefined(inputParam_MessageObject.l_users_visa_to) &&
         inputParam_MessageObject.l_users_visa_to.length > 0 ? 
            inputParam_MessageObject.l_users_visa_to.map(x => (
                {
                    ...x,
                    key: x.username,
                    text : x.fullname,
                    onRenderField: (props, render) => {
                        return (
                            <Row>
                                <Col>{render(props)}</Col>
                                <Col className='col-auto ms-auto'>
                                    <Card style={{minWidth: "175px"}}>
                                        <div className="p-1">
                                            <Row>
                                                <Col>
                                                    <div style={{ fontSize: "12px"}}>
                                                        <div>
                                                            {
                                                                props.answeredStatusName === "data-lang-sbsectionpartymessage-answered0" ?
                                                                <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--MailAlert` } ></i> : <></>
                                                            }
                                                            {
                                                                props.answeredStatusName === "data-lang-sbsectionpartymessage-answered1" ?
                                                                <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--Mail` } ></i> : <></>
                                                            }
                                                            {
                                                                props.answeredStatusName === "data-lang-sbsectionpartymessage-answered2" ?
                                                                <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--SendMirrored` } ></i> : <></> 
                                                            }
                                                            {
                                                                props.answeredStatusName === "data-lang-sbsectionpartymessage-answered3" ?
                                                                <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--ReminderTime` } ></i> : <></>
                                                            }
                                                            {
                                                                props.answeredStatusName === "data-lang-sbsectionpartymessage-answered4" ?
                                                                <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--EventDateMissed12` } ></i> : <></>
                                                            }
                                                            &nbsp;{t(props.answeredStatusName)}
                                                        </div>
                                                        <div>
                                                        {
                                                            props.readStatusName === "data-lang-sbsectionpartymessage-read0" ?
                                                            <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--RadioBtnOff` } ></i> : <></>
                                                        }
                                                        {
                                                            props.readStatusName === "data-lang-sbsectionpartymessage-read1" ?
                                                            <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--MailAlert` } ></i> : <></>
                                                        }
                                                        {
                                                            props.readStatusName === "data-lang-sbsectionpartymessage-read2" ?
                                                            <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={ `ms-Icon ms-Icon--Read` } ></i> : <></>
                                                        }
                                                        &nbsp;{t(props.readStatusName)}
                                                        </div>
                                                        {
                                                            inputParam_MessageObject && props.principal === true && inputParam_MessageObject.visa !== 1 &&inputParam_MessageObject.visa !== 2 &&
                                                            <div>
                                                                <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } }  className={`ms-Icon ms-Icon--AlarmClock`} ></i>
                                                                &nbsp;{t('data-lang-lbl-visapending')}
                                                            </div>
                                                        }
                                                        {
                                                            inputParam_MessageObject && props.principal === true && inputParam_MessageObject.visa === 2 &&
                                                            <div>
                                                                <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={`ms-Icon ms-Icon--StatusErrorFull`} ></i>
                                                                &nbsp;{((inputParam_MessageObject.visa === 2 ? t('data-lang-lbl-visarejected') : t('data-lang-lbl-visarejected')))}
                                                            </div>                                                }
                                                        {
                                                            inputParam_MessageObject && props.principal === true && inputParam_MessageObject.visa === 1 &&
                                                                                                                <div>
                                                                <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={`ms-Icon ms-Icon--SkypeCircleCheck`} ></i>
                                                                &nbsp;{((inputParam_MessageObject.visa === 1 ? t('data-lang-lbl-visaaproved') : t('data-lang-lbl-visaaproved')))}
                                                            </div>
                                                        }
                                                        {
                                                            inputParam_MessageObject && props.principal === true && inputParam_MessageObject.visa === 3 &&
                                                            <div>
                                                                <i style={ { fontSize: 20, verticalAlign: "middle", color: "#0078d4" } } className={`ms-Icon ms-Icon--AlertSolid`} ></i>
                                                                &nbsp;{(props.resultVisa === true ? t('data-lang-lbl-visaaprovedbreak') : t('data-lang-lbl-visarejectedbreak'))}
                                                            </div>
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Card>
                                </Col>
                            </Row>
                        );
                    }
                })) :
                null
            );

    const gridRef = useRef(null);
    const [notificationPivotItemActive, setNotificationPivotItemActive] = useState('0')
    const [notificationCommentList, setNotificationCommentList] = useState(null)
    useOfBookMessageComments(inputParam_BookObject.id, inputParam_MessageObject.id, inputParam_NotificationMode, notificationCommentList, setNotificationCommentList)

    const [fireDistributionGroupSearch, setFireDistributionGroupSearch] = useState(false);
    const [selectedDistributionGroup, setSelectedDistributionGroup] = useState(null);
    useGetListUserDistributionGroup(!isNullUndefined(selectedDistributionGroup) ? selectedDistributionGroup.id : null, distributionGroupUsersList, setDistributionGroupUsersList, inputParam_IsPanelOpen, fireDistributionGroupSearch, setFireDistributionGroupSearch)


    const [fireEvent, setFireEvent] = useState(true);

    const [fireGetSectionByParties, setFireGetSectionByParties] = useState(true);
    const [sectionList, setSectionList] = useState(null);
    useGetSectionsByPartyId(
        !isNullUndefined(inputParam_MessageObject) && inputParam_NotificationMode === false ? inputParam_UserProps.partyId : inputParam_MessageObject.sendedPartyId, 
        !isNullUndefined(inputParam_MessageObject) && inputParam_NotificationMode === false ? inputParam_UserProps.partyMemberId : 0, 
        sectionList, setSectionList, 
        null, 
        true, 
        true, 
        [inputParam_MessageObject.sectionId], 
        inputParam_IsPanelOpen,
        null,
        {fireGetSectionByParties,
        setFireGetSectionByParties}
    );
    
    const [sectionPartyList, setSectionPartyList] = useState(null);
    useGetSectionPartyFullsByBookId(
        inputParam_BookObject.id,
        objMensaje && objMensaje.section_id,
        sectionPartyList,
        setSectionPartyList,
        null,
        inputParam_IsPanelOpen && fireEvent,
        setFireEvent,
        true,
        true,
        inputParam_MessageObject.id !== null ? inputParam_MessageObject.l_partys_to.map(a => a.sectionPartyId) : []);

    const [documentsToDeleteAfterBreakVisaSave, setDocumentsToDeleteAfterBreakVisaSave] = useState([]);
    const [documentMessageList, setDocumentMessageList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});
    
    const [dataFilled, setDataFilled] = useState(false);
    useGetDocumentListByMessage(objMensaje && objMensaje.item_message.id, documentMessageList, setDocumentMessageList, inputParam_IsPanelOpen, dataFilled, setDataFilled);
    const [hideActionButtons, setHideActionButtons] = useState(false);


    //Para manejar el scroll.
    const targetRef = useRef(null);
    const [scrollRoot, setScrollRoot] = useState(null);

    //Eventos de componente.
    const isInValidFormControl = (statusId, notificationOperation) => {
        let isInvalidForm = false;

        if (objMensaje.item_message.messageCode === "") {
            setTxtCodeIsInValid(true);
            isInvalidForm = true;
        }
        else{
            setTxtCodeIsInValid(false);
        }

        if (objMensaje.item_message.title === "") {
            setTxtNameIsInValid(true);
            isInvalidForm = true;
        }
        else{
            setTxtNameIsInValid(false);
        }

        if (objMensaje.item_message.body === "") {
            setTxtBodyIsInValid(true);
            isInvalidForm = true;
        }
        else{
            setTxtBodyIsInValid(false);
        }

        if (objMensaje.item_message.topicId <= 0 || objMensaje.item_message.topicId === null) {
            setIsInvalidTemplateSection(true);
            isInvalidForm = true;
        }
        else {
            setIsInvalidTemplateSection(false);
        }

        if (objMensaje.item_message.sectionId === null) {
            setIsInvalidSection(true);
            isInvalidForm = true;
        }
        else{
            setIsInvalidSection(false);
        }

        if (objMensaje.l_section_party_to_ids.length === 0) {
            setIsInvalidSectionParty(true);
            isInvalidForm = true;
        }
        else{
            setIsInvalidSectionParty(false);
        }

        if (inputParam_NotificationMode === false) {
            const isManagerPartyMember = inputParam_UserProps && inputParam_UserProps.l_privilegeselement && inputParam_UserProps.l_privilegeselement.find(x => x.managerParty === true) !== undefined;
            if (isManagerPartyMember) {
                if (objMensaje.item_message.answerNeeded && objMensaje.item_message.visa !== null && objMensaje.item_message.visa !== 0 && objMensaje.item_message.visa !== 2) {
                    if (objMensaje.item_message.answerDeadlineDate === null) {
                        setPickerAnswerDeadlineDateIsInValid(true);
                        isInvalidForm = true;
                    }
                    else {
                        setPickerAnswerDeadlineDateIsInValid(false);
                    }
                }
            }
            else {
                if (objMensaje.item_message.answerNeeded) {
                    if (objMensaje.item_message.answerDeadlineDate === null) {
                        setPickerAnswerDeadlineDateIsInValid(true);
                        isInvalidForm = true;
                    }
                    else {
                        setPickerAnswerDeadlineDateIsInValid(false);
                    }
                }
            }
        }
        else {
            const result = notificationCommentList.length === 0 ? false : ( inputParam_NotificationTask.iteration === null ? notificationCommentList.length > 0 : notificationCommentList.some(x => parseInt(x.messageEventName.split('#')[1]) === inputParam_NotificationTask.iteration));

            if (notificationOperation === false && statusId === enum__MessageStatus.TOVISA && !result) {
                setIsInvalidVisaRejectedComment(true);
                setNotificationPivotItemActive('1');
                isInvalidForm = true;
            }
            else{
                setIsInvalidVisaRejectedComment(false);
            }
        }

        if (objMensaje.item_message.visa === 0 && isNullUndefined(distributionGroupUsersList)) {
            isInvalidForm = true;
            setIsInvalidDistributionGroupList(true);
        }
        else {
            setIsInvalidDistributionGroupList(false);

            if (!isNullUndefined(distributionGroupUsersList) && isNullUndefined(distributionGroupUsersList.find(x => x.principal === true))) {
                isInvalidForm = true;
                setIsInvalidDistributionGroupUserList(true);
            }
            else {
                setIsInvalidDistributionGroupUserList(false);
            }
        }

        return isInvalidForm;
    };

    const onHideActionButtons = () => {
        setHideActionButtons(true)
    };

    const onDeleteMessage = (statusId) => {

        const matchedSectionPartyForDelete = inputParam_UserProps.l_SectionPartyMemberHandler.find(x => x.sectionId === (inputParam_MessageObject.sectionId !== null ? inputParam_MessageObject.sectionId : null));
        const sectionPartyMemberId = inputParam_UserProps.username !== null && inputParam_MessageObject.id !== null ?
            (matchedSectionPartyForDelete !== undefined ? matchedSectionPartyForDelete.sectionPartyMemberId : null) : null;

        setActionInProgress(true);
        hideDeleteMessageDialog();
        deleteMessage(inputParam_BookObject.id, inputParam_MessageObject.id, sectionPartyMemberId).then((response) => {
            if (response.data.succeeded) {

                onHideActionButtons();
                
                inputParam_SetterObjMessage && inputParam_SetterObjMessage(prevState => ({
                    ...prevState,
                    deactivate: true
                }));

                inputParam_SetterObjMessageList && inputParam_SetterObjMessageList(null);

                setShowMessage(true)
                setMessageType("success");
                setMessage(t('data-lang-msg-operationperformed'))

                inputParam_SetterIsPanelOpen(true);
            }
            else {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            }
            setActionInProgress(false);
        }).catch(() => {
            setShowMessage(true)
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
            setActionInProgress(false);
        });
    };

    
    const onPreActionOpenVisa = () => {
        showBreakVisaMessageDialog()
    }

    const onActionOpenVisa = (visaId, isCancel = false) => {
        if (isCancel === false) {
            let item_message = { ...objMensaje.item_message }
            item_message.visa = visaId;

            setObjMensaje(prevState => ({
                ...prevState,
                item_message: item_message
            }));
        }
        else {
            setForceSetMessageObject(true);
            setSectionList(null);
            setFireEvent(true);
        }

        setEditMode(inputParam_ParentEditMode === false ? inputParam_ParentEditMode : (inputParam_NotificationMode === false ? visaId === 3 : false));
        hideBreakVisaMessageDialog();
    };

    const persistDeleteVisaBreakDocuments = (documents) => {
        if (documents.length > 0) {
            documents.forEach(async documentToDelete => {
                await removeDocumentByMessageDocument(documentToDelete.id).then((response) => {
                    if(response.data.succeeded) {

                        setDocumentMessageList(prevState => ({
                            ...prevState,
                            fireUpdate: true,
                            data: documentMessageList.data.filter(x => x.id !== itemToDelete.id)
                        }));
                    }
                }).catch(() => {
                });
            });

            setDocumentsToDeleteAfterBreakVisaSave([]);
        }
    }

    const onChangeTemplateSection = (currentNode, selectedNodes) => {
        let items = [...topicList];

        items.forEach(x => {
            if (x.id === currentNode.id) {
                x.checked = currentNode.checked;
            }
            else {
                x.checked = false;
            }
        })

        let item_message = { ...objMensaje.item_message }
        item_message.topicId = currentNode.checked ? currentNode.id : null;
        item_message.messageTopicCode = currentNode.checked ? currentNode.code : null;


        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));

        setTopicList(items); 
    }

    const onActionMessage = (statusId, notificationCompleted = null) => {
        // Eliminar (0) solo abre la confirmación: «Ejecutando» se enciende en onDeleteMessage, al confirmar.
        if (statusId !== 0) {
            setActionInProgress(true);
        }

        if (inputParam_NotificationMode === true) {
            objMensaje.section_party_from_id = inputParam_MessageObject.sectionPartySenderId;
            objMensaje.section_party_member_id = 0;
        }

        if (objMensaje.item_message.visa === 1) {
            objMensaje.item_message.visa === 5;
        }

        // !== 0 => Eliminar
        if (statusId !== 0) {
            //[##CODELCO-CARD-6-##]
            if (inputParam_BookObject.hasMilestone === true && inputParam_BookObject.l_book_milestone.some(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.APERTURA) === true) {
                //[##CODELCO-CARD-6-##]
                //Las comunicaciones de hito las envían solamente la parte Administradora
                if (inputParam_BookObject.needInitMilestone === true) {
                    if ((inputParam_BookObject.hasInitMilestone === false)) {
                        //if (objMensaje.item_message.messageTopicCode === "MSGTC-INIT") {
                        if (objMensaje.item_message.messageTopicCode.startsWith("MSGTC-INIT")) {
                            //[##CODELCO-CARD-6-##]
                            //Si se consideran hitos, no se pueden generar otras comunicaciones antes del hito de inicio
                            if (inputParam_NotificationMode !== true) {
                                if (inputParam_UserProps.partyId !== inputParam_BookObject.milestoneToStartPartyId) {
                                    setShowMessage(true)
                                    setMessageType("warning");
                                    setMessage(t('data-lang-msg-milestonestartpartynotmember'))
                                    setActionInProgress(false);
                                    return;
                                }
                            }
                        }
                        else {
                            setMessage(t('data-lang-msg-milestorestartneeded'))
                            setActionInProgress(false);
                            return;
                        }
                    }
                }                

                //[##CODELCO-CARD-6-##]
                //Las comunicaciones de hito las envían solamente la parte Administradora
                if (inputParam_BookObject.canEndMilestone) {
                    //[##CODELCO-CARD-6-##]
                    //Usuario no pertenece a la parte administradora que puede enviar la comunicación de cierre
                    if (inputParam_UserProps.partyId === inputParam_BookObject.milestoneToEndPartyId && objMensaje.item_message.sectionPartySenderId === inputParam_BookObject.milestoneToEndPartyId) {
                        setShowMessage(true)
                        setMessageType("warning");
                        setMessage(t('data-lang-msg-milestoneendnotmember'))
                        setActionInProgress(false);
                        return;
                    }
                }
            }
        }

        //Solo cuando se envia, dado que quien envia podria ser un aprobador, se sobre escribe quien la envia.
        if (statusId === 4) {
            objMensaje.item_message.senderUsername = inputParam_CurrentUserName;
        }
        
        if (statusId === 0) {
            showDeleteMessageDialog();
        }
        else {
            if (isInValidFormControl(statusId, notificationCompleted) === false) {
                objMensaje.book_id = inputParam_BookObject.id;
                objMensaje.item_message.attacheds = documentMessageList.data !== null ? documentMessageList.data.length > 0 : false;
                objMensaje.item_message.statusId = statusId;

                if (objMensaje.item_message.statusId === enum__MessageStatus.TOVISA && objMensaje.item_message.visa === 2) {
                    objMensaje.item_message.visa = 0;
                }
                else if (objMensaje.item_message.statusId === enum__MessageStatus.TOVISA && inputParam_NotificationMode === true && objMensaje.item_message.visa === 0) {
                    objMensaje.item_message.visa = notificationCompleted === true ? 1 : 2;
                    //Actualizar bandaja.
                    //Actualizar número de pendientes superior.
                    if (!isNullUndefined(notificationTaskMenuData)) {
                        notificationTaskMenuData.map(itemMenu => {
                            if (itemMenu.item1 === enum__NOTIFICATION_INBOX_TYPE.UNFULFILLED) { itemMenu.item2 = itemMenu.item2 -1; }
                            if (itemMenu.item1 === enum__NOTIFICATION_INBOX_TYPE.COMPLETED) { itemMenu.item2 = itemMenu.item2 +1; }
                        })
                        dispatch(action_setNotificacionTaskMenuItems(notificationTaskMenuData));   
                    }
                    
                    dispatch(action_updateEdPPrepareForceGetHeader(true));
                }

                updateMessage(objMensaje).then(async (responseMessage) => {
                    //Supuestamente se devolverá el mismo listado pero con ids, esto hará que las opciones de "seleccionar usuario" de las cards nuevas aparezca, dado que ahora la card poseerá id.
                    //El listado retornano no posee los "name" de section y party, es por esto que se establece en null, para que vuelva a buscar los datos con los parametros indicados.
                    //Si es requerido que no se busquen nuevamente los datos, el retorno debe traer las propiedades y se deben asignar.
                    
                    if (responseMessage.data.succeeded) {
                        if (objMensaje.item_message.visa === 3 && inputParam_MessageObject.visa !== 3) {
                            persistDeleteVisaBreakDocuments(documentsToDeleteAfterBreakVisaSave);
                        }

                        let resultFlagDocument = false;
                        let resultFlagNotification = false;
                        let serviceDistributionGroupStatus = false;
                        
                        if (documentMessageList.data !== null && documentMessageList.data.length > 0) {
                            const documentsToAdd = documentMessageList.data.filter(x => x.onTheFlyDocument === true)
                            const documents = documentMessageList.data.filter(x => x.onTheFlyDocument !== true) 
                            const aux_documentsToAdd = [];
        
                            documentsToAdd.map((document, index) => (  
                                aux_documentsToAdd.push({
                                    id : 0,
                                    messageId : objMensaje.id,
                                    statusId : null,
                                    documentId : document.id
                                })
                            ))
        
                            documents.map((document, index) => (  
                                aux_documentsToAdd.push({
                                    id : 0,
                                    messageId : objMensaje.id,
                                    statusId : null,
                                    documentId : document.id
                                })
                            ))
                            
                            const messageId = responseMessage.data.data;
            
                            await addListDocumentByMessage(messageId, aux_documentsToAdd).then((response) => {
        
                                setDocumentMessageList(prevState => ({
                                    ...prevState,
                                    fireUpdate: true,
                                    data: response.data.data
                                }));

                                inputParam_SetterDocumentList && inputParam_SetterDocumentList(prevState => ({
                                    ...prevState,
                                    fireUpdate: true,
                                    data: response.data.data
                                }));

                                onHideActionButtons();
                                inputParam_SetterObjMessageList && inputParam_SetterObjMessageList(null);
                                inputParam_SetterObjMessage({
                                    id: objMensaje.item_message.id,
                                    messageNemo: objMensaje.item_message.messageNemo,//Not null
                                    messageCode: objMensaje.item_message.messageCode,//Not null
                                    correlative: objMensaje.item_message.correlative,
                                    title: objMensaje.item_message.title,
                                    body: objMensaje.item_message.body,
                                    topicId: objMensaje.item_message.topicId,
                                    senderUsername: objMensaje.item_message.senderUsername,//Not null
                                    sectionPartySenderId: objMensaje.item_message.sectionPartySenderId,//Not null
                                    sendDate: objMensaje.item_message.sendDate,
                                    answerNeeded: objMensaje.item_message.answerNeeded,
                                    answerToMessage: objMensaje.item_message.answerToMessage,
                                    answerMessageNemo: objMensaje.item_message.answerMessageNemo,
                                    answerMessageId: objMensaje.item_message.answerMessageId,
                                    answerDeadlineDate: objMensaje.item_message.answerDeadlineDate,
                                    attacheds: objMensaje.item_message.attacheds,
                                    statusId: objMensaje.item_message.statusId,
                                    //sin la visación, un «Editar» antes de la recarga mostraba el botón de visar
                                    visa: objMensaje.item_message.visa ?? null,
                                    l_users_visa_to: inputParam_MessageObject.l_users_visa_to,

                                    signatureQR: inputParam_MessageObject.signatureQR,
                                    statusName: "data-lang-sbmessage-status" + objMensaje.item_message.statusId,
                                    sendedPartyName: inputParam_MessageObject.sendedPartyName,
                                    sendedPartyId: inputParam_MessageObject.sendedPartyId,
                                    sectionName: inputParam_MessageObject.sectionName,
                                    answerMessageCode: inputParam_MessageObject.answerMessageCode,
                                    hasSignature: inputParam_MessageObject.hasSignature,
                                    sectionId: inputParam_MessageObject.sectionId,
                                    deactivate: inputParam_MessageObject.deactivate,
                                    l_partys_to: inputParam_MessageObject.l_partys_to,
                                    l_section_party_to_ids:  inputParam_MessageObject.l_section_party_to_ids
                                });
                                
                                resultFlagDocument = true;
                            }).catch(() => {
                                resultFlagDocument = false;
                            });
                        }
                        else {
                            onHideActionButtons();
                            inputParam_SetterObjMessageList && inputParam_SetterObjMessageList(null);
                            objMensaje.item_message.statusId = statusId;
                            inputParam_SetterObjMessage({
                                id: objMensaje.item_message.id,
                                messageNemo: objMensaje.item_message.messageNemo,//Not null
                                messageCode: objMensaje.item_message.messageCode,//Not null
                                correlative: objMensaje.item_message.correlative,
                                title: objMensaje.item_message.title,
                                body: objMensaje.item_message.body,
                                topicId: objMensaje.item_message.topicId,
                                senderUsername: objMensaje.item_message.senderUsername,//Not null
                                sectionPartySenderId: objMensaje.item_message.sectionPartySenderId,//Not null
                                sendDate: objMensaje.item_message.sendDate,
                                answerNeeded: objMensaje.item_message.answerNeeded,
                                answerToMessage: objMensaje.item_message.answerToMessage,
                                answerMessageNemo: objMensaje.item_message.answerMessageNemo,
                                answerMessageId: objMensaje.item_message.answerMessageId,
                                answerDeadlineDate: objMensaje.item_message.answerDeadlineDate,
                                attacheds: objMensaje.item_message.attacheds,
                                statusId: objMensaje.item_message.statusId,
                                //sin la visación, un «Editar» antes de la recarga mostraba el botón de visar
                                visa: objMensaje.item_message.visa ?? null,
                                l_users_visa_to: inputParam_MessageObject.l_users_visa_to,

                                signatureQR: inputParam_MessageObject.signatureQR,
                                statusName: "data-lang-sbmessage-status" + objMensaje.item_message.statusId,
                                sendedPartyName: inputParam_MessageObject.sendedPartyName,
                                sendedPartyId: inputParam_MessageObject.sendedPartyId,
                                sectionName: inputParam_MessageObject.sectionName,
                                answerMessageCode: inputParam_MessageObject.answerMessageCode,
                                hasSignature: inputParam_MessageObject.hasSignature,
                                sectionId: inputParam_MessageObject.sectionId,
                                deactivate: inputParam_MessageObject.deactivate,
                                l_partys_to: inputParam_MessageObject.l_partys_to,
                                l_section_party_to_ids:  inputParam_MessageObject.l_section_party_to_ids
                            });
                            resultFlagDocument = true;
                        }

                        if (inputParam_NotificationMode === true) {
                            await setNotificationCompleted(inputParam_NotificationTask.id, notificationCompleted).then(async (responseNotification) => {
                                if (responseMessage.data.succeeded) {
                                    resultFlagNotification = true;
                                    //Actualizar bandaja.
                                    //Actualizar número de pendientes superior.
                                    if (!isNullUndefined(notificationTaskDataList)) {
                                        notificationTaskDataList.map(item => { if (item.id === inputParam_NotificationTask.id) { item.completed = true; } })
                                        dispatch(action_setNotificacionTaskList(notificationTaskDataList));
                                    }
                                    if (!isNullUndefined(notificationTaskDataListFiltred)) {
                                        notificationTaskDataListFiltred.map(item => { if (item.id === inputParam_NotificationTask.id) { item.completed = true; } })
                                        dispatch(action_setNotificacionTaskListFiltred(notificationTaskDataListFiltred));
                                    }
                                    if (!isNullUndefined(alertList)) {
                                        alertList.map(item => { if (item.id === inputParam_NotificationTask.id) { item.completed = true; } })
                                        dispatch(action_updateAlertList(alertList));
                                    }
                                }
                                else {
                                    resultFlagNotification = false;
                                }
                            }).catch(() => {
                                resultFlagNotification = false;
                            });
                        }
                        else {
                            if (!isNullUndefined(objMensaje.item_message.visa) && objMensaje.item_message.statusId === enum__MessageStatus.TOVISA) {
                                const l_cc = distributionGroupUsersList.filter(x => x.principal === false && x.userAuthProfileId !== null);
                                const aux_visaUsers = {
                                    message_id: objMensaje.id,
                                    principal_user_auth_id: distributionGroupUsersList.find(x => x.principal === true).userAuthProfileId,
                                    l_cc_user_auth_id: !isNullUndefinedOrEmpty(l_cc) && l_cc.length > 0 ? l_cc.map(x => x.userAuthProfileId) : null
                                }
                                
                                await saveMessageVisa(aux_visaUsers).then((response) => {
                                    serviceDistributionGroupStatus = true;
                                }).catch(() => {
                                    serviceDistributionGroupStatus = false;
                                });
                            }
                            else {
                                serviceDistributionGroupStatus = true;
                            }
                        }

                        if (resultFlagDocument === true &&  (inputParam_NotificationMode === true ? resultFlagNotification === true : serviceDistributionGroupStatus === true)) {
                            setShowMessage(true)
                            setMessageType("success");
                            setMessage(t('data-lang-msg-operationperformed'))
                        }
                        else {
                            setShowMessage(true)
                            setMessageType("error");
                            setMessage(t('data-lang-msg-operationerror'))
                        }
                    }
                    else {
                        setShowMessage(true)
                        setMessageType("error");
                        setMessage(t('data-lang-msg-operationerror'))
                    }

                    if (inputParam_NotificationMode !== true) {
                        inputParam_SettFireGetMessage && inputParam_SettFireGetMessage(true);
                    }
                    setActionInProgress(false);
                }).catch(() => {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                    setActionInProgress(false);
                });
            } else {
                setShowMessage(true)
                setMessageType("warning");
                setMessage(t('data-lang-msg-requireddatanotset'))
                setActionInProgress(false);
            }
        }
    };

    const onSaveNotificationComment = () => {
        const messageComment =
        {
            id: 0,
            messageId: inputParam_MessageObject.id !== null ? inputParam_MessageObject.id : 0,
            sectionPartyMemberId: null,
            messageEventNemo: null,
            messageEventDate: new Date(),
            messageEventUsername: inputParam_CurrentUserName,
            messageEventFullname: inputParam_CurrentUserName,
            messageEventName: "data-lang-sbmessageevent-type-comment-visa",
            messageEventDesc: notificationComment,
            messageStatusId: inputParam_MessageObject.statusId !== null ? inputParam_MessageObject.statusId : 0,
            messageEventTypeId: null,
        }
        saveMessageComment(messageComment).then((response) => {
            setShowMessage(true)
            setMessageType("success");
            setMessage(t('data-lang-msg-operationperformed'))
            messageComment.id = response.data.data;
            messageComment.messageEventName = `"data-lang-sbmessageevent-type-comment-visa#${inputParam_NotificationTask.iteration === null ? 1 : inputParam_NotificationTask.iteration}`;
            notificationCommentList.unshift(messageComment);
            setNotificationComment('');
            setIsInvalidVisaRejectedComment(false);
        }).catch(() => {
            setShowMessage(true)
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
        });
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const setAditionalDocumentMessageList = (modalDocumentList) => {
        let item_documentList = { ...documentMessageList.data }
        item_documentList = documentMessageList.data !== null ? joinWithoutDupes(documentMessageList.data, modalDocumentList, "id") : modalDocumentList;

        setDocumentMessageList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: item_documentList
        }));
    };

    const setMessageTitle = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.title = (value !== null ? value : "");

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    };

    const setMessageCode = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.messageCode = (value !== null ? value : "");

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    };

    const setMessageBody = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.body = (value !== null ? value : "");

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    };

    const setMessageAnswerDeadlineDate = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.answerDeadlineDate = value.toISOString();

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    };

    const onChangeSection = (currentNode, selectedNodes) => {
        const matchedSectionPartyForSection = inputParam_UserProps.l_SectionPartyMemberHandler.find(x => x.sectionId === (currentNode !== null ? currentNode.id : null));

        let item_message = { ...objMensaje.item_message }
        item_message.sectionId = (currentNode !== null ? currentNode.id : null);
        item_message.sectionPartySenderId = inputParam_UserProps.username !== null ? (matchedSectionPartyForSection !== undefined ? matchedSectionPartyForSection.sectionPartyId : null) : null;

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));

        // los destinatarios son de la sección: al cambiarla hay que volver a elegirlos (en la original vuelven los que tenía)
        setObjMensaje(prevState => ({
            ...prevState,
            section_id: (currentNode !== null ? currentNode.id : null),
            l_section_party_to_ids: currentNode !== null && currentNode.id === inputParam_MessageObject.sectionId ? (inputParam_MessageObject.l_partys_to || []).map(a => a.sectionPartyId) : []
        }));
        setObjMensaje(prevState => ({
            ...prevState,
            section_party_from_id: inputParam_UserProps.username !== null ? (matchedSectionPartyForSection !== undefined ? matchedSectionPartyForSection.sectionPartyId : null) : null
        }));
        setObjMensaje(prevState => ({
            ...prevState,
            section_party_member_id: inputParam_UserProps.username !== null ? (matchedSectionPartyForSection !== undefined ? matchedSectionPartyForSection.sectionPartyMemberId : null) : null,
        }));


        let items = [...sectionList];

        items.forEach(x => {
            if (x.id === currentNode.id) {
                x.checked = currentNode.checked;
            }
            else {
                x.checked = false;
            }
        })

        setSectionList(items); 
        setFireEvent(true);
    };

    const onChangeSectionParty = (currentNode, selectedNodes) => {

        let l_section_party_to_ids = { ...objMensaje.l_section_party_to_ids }    
        l_section_party_to_ids = [];
        selectedNodes.forEach(element => {
            l_section_party_to_ids.push(element.id);
        });

        setObjMensaje(prevState => ({
            ...prevState,
            l_section_party_to_ids: l_section_party_to_ids
        }));

        let items = [...sectionPartyList];

        items.forEach(x => {
            x.checked = false;
            selectedNodes.forEach(element => {
                if (x.id === element.id) {
                    x.checked = true;
                }       
            });
        })

        setSectionPartyList(items); 
    };

    const onChangeRequiresAnswer = (e, checked) => {
        let item_message = { ...objMensaje.item_message }
        item_message.answerNeeded = checked;

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    };

    const onChangeVisa = (e, checked) => {
        let item_message = { ...objMensaje.item_message }
        const visa = cloneDeep(item_message.visa);
        item_message.visa = checked === false ? null : (visa === null ? 0 : visa);

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    };

    const onDeleteDocumentFromListClick = (item, setItemToDelete) => {
        setItemToDelete(item);
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onHideDeleteMessageDialog = (ev) => {
        ev.preventDefault();
        hideDeleteMessageDialog();
        inputParam_SetterIsPanelOpen(true);
    };

    const onHideBreakVisaMessageDialog = (ev) => {
        ev.preventDefault();
        hideBreakVisaMessageDialog();
        setIsPanelBreakVisaOpen(true);
    };

    const onDismissPanel = () => {
        setPickerAnswerDeadlineDateIsInValid(false);
        inputParam_SetterIsPanelOpen(false);
        setSectionPartyList(null);
        setFireEvent(true);
        setHideActionButtons(false);
        setObjMensaje(null);
        setDocumentMessageList(prevState => ({
            ...prevState,
            data: null
        }));
    };

    const onDownloadDocumentsByIds = (documentList, fileName) => {
        downloadDocumentsByIds(documentList).then((response) => {
            saveByteArray(fileName, base64ToArrayBuffer(response.data.data));
        }).catch(() => {
            setShowMessage(true)
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
        });
    };

    const onRenderFooterContent = () => {
        if (inputParam_NotificationMode === true) {
            return <>
                        <Row>
                            <Col xl={12}>
                                <Message message={ message } display={ showMessage === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
                            </Col>
                            {
                                isInView ?
                                <Col xl={12}>
                                    {
                                        documentMessageList.data !== null &&
                                        <ListPagination
                                            listLocalStoragePageSizeVariableName="messageBoxEditPanelDocuments"
                                            data={ documentMessageList }
                                            setData={ setDocumentMessageList }
                                        />
                                    }
                                </Col> : <></>
                            }
                            <Col xl={12}>
                                <div className='d-flex'>
                                    {
                                        !hideActionButtons && (inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate) &&
                                        <>
                                            {
                                                !actionInProgress &&inputParam_ParentEditMode === true && inputParam_NotificationTask.completed !== true &&
                                                <>
                                                    <PrimaryButton onClick={ () => onActionMessage(5, true) } styles={_global_buttonStyles}>{ 'Enviar aceptación' }</PrimaryButton>
                                                    <PrimaryButton onClick={ () => onActionMessage(5, false) } styles={_global_buttonStyles}>{ 'Enviar rechazo' }</PrimaryButton>
                                                </>
                                            }
                                            {
                                                actionInProgress &&
                                                <Loading
                                                    inputParam_Style={{marginTop: 0}}
                                                    inputParam_ShowLoading={true}
                                                    inputParam_ShowText={true}
                                                    inputParam_Text={t('data-lang-lbl-executing')}
                                                    inputParam_Position="unset"
                                                    inputParam_Width="20px"
                                                    inputParam_Height="20px"
                                                    inputParam_Vertical={false}
                                                    inputParam_ColClassName="my-auto"
                                                    inputParam_EjecutingTextClass={"ps-4"}
                                                    inputParam_Left="87%"
                                                    inputParam_Top="11px"
                                                    inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                                                />
                                            }
                                        </>
                                    }
                                    <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                                </div>
                            </Col>
                        </Row>
                    </>
        }
        else {
            return  <Row>
                        <Col xl={12}>
                            <Message message={ message } display={ showMessage === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
                        </Col>
                        {
                            isInView ?
                            <Col xl={12}>
                                {
                                    documentMessageList.data !== null &&
                                    <ListPagination
                                        listLocalStoragePageSizeVariableName="messageBoxEditPanelDocuments"
                                        data={ documentMessageList }
                                        setData={ setDocumentMessageList }
                                    />
                                }
                            </Col> : <></>
                        }
                        <Col xl={12}>
                            <div className='d-flex'>
                                {
                                !actionInProgress && !hideActionButtons && (inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate) && objMensaje &&
                                    <>
                                        {
                                            !visibilityButtonSave(inputParam_MessageObject !== null ? inputParam_MessageObject.statusId : 0, inputParam_UserProps, inputParam_BookObject !== null ? inputParam_BookObject.requiresApproval : null, inputParam_MessageObject.visa) &&
                                            <PrimaryButton onClick={ () => onActionMessage(objMensaje.item_message.statusId !== enum__MessageStatus.ONAPROBATION ? (objMensaje.item_message.visa === 3 ? 5 : 1) : objMensaje.item_message.statusId) } styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>
                                        }
                                        {
                                            !visibilityButtonSendToApprove(inputParam_MessageObject !== null ? inputParam_MessageObject.statusId : 0, inputParam_UserProps, inputParam_BookObject !== null ? inputParam_BookObject.requiresApproval : null) &&
                                            <PrimaryButton onClick={ () => onActionMessage(3) } styles={_global_buttonStyles}>{ t('data-lang-btn-sendtoapprove') }</PrimaryButton>
                                        }
                                        {
                                            !visibilityButtonSend(inputParam_MessageObject.id, inputParam_MessageObject !== null ? inputParam_MessageObject.statusId : 0, inputParam_UserProps, inputParam_BookObject !== null ? inputParam_BookObject.requiresApproval : null, false, inputParam_MessageObject.visa === 1 || (inputParam_MessageObject.visa === 3 || objMensaje.item_message.visa === 3)) &&
                                            <PrimaryButton onClick={ () => onActionMessage((objMensaje.item_message.visa === null || objMensaje.item_message.visa === 1 || objMensaje.item_message.visa === 3) ? enum__MessageStatus.SENDED : enum__MessageStatus.TOVISA) } styles={_global_buttonStyles}>{ (objMensaje.item_message.visa === null || objMensaje.item_message.visa === 1 || objMensaje.item_message.visa === 3) ? t('data-lang-btn-send') : t('data-lang-btn-visa') }</PrimaryButton>
                                        }
                                        {
                                            !visibilityButtonBreakeVisa(inputParam_MessageObject !== null ? inputParam_MessageObject.statusId : 0, inputParam_UserProps, (inputParam_BookObject !== null ? inputParam_BookObject.requiresApproval : null), (inputParam_MessageObject.visa === null ? false : inputParam_MessageObject.visa >= 0)) &&
                                            <>
                                                {
                                                    objMensaje && objMensaje.item_message.visa === 2 &&
                                                    <PrimaryButton onClick={ () => onActionMessage(enum__MessageStatus.TOVISA) } styles={_global_buttonStyles}>{ t('data-lang-btn-revisa') }</PrimaryButton>
                                                }
                                                {
                                                    objMensaje && objMensaje.item_message.visa !== 3 &&  objMensaje && objMensaje.item_message.visa !== 0 &&
                                                    <PrimaryButton onClick={ () => onPreActionOpenVisa() } styles={_global_buttonStyles}>{ t('data-lang-btn-openvisa') }</PrimaryButton>
                                                }
                                                {
                                                    objMensaje && objMensaje.item_message.visa === 3 &&
                                                    <PrimaryButton onClick={ () => onActionOpenVisa(inputParam_MessageObject.visa, true) } styles={_global_buttonStyles}>{ t('data-lang-btn-calcelopenvisa') }</PrimaryButton>
                                                }
                                            </>
                                        }
                                        {
                                            objMensaje && !visibilityButtonDelete(inputParam_MessageObject !== null ? inputParam_MessageObject.statusId : 0, inputParam_UserProps, (objMensaje.item_message.visa === null ? false : objMensaje.item_message.visa >= 0), (objMensaje.item_message.visa === 3)) &&
                                            <DefaultButton onClick={ () => onActionMessage(0) } styles={_global_buttonStyles}>{ t('data-lang-btn-delete') }</DefaultButton>
                                        }
                                    </>
                                }
                                {
                                    actionInProgress &&
                                    <Loading
                                        inputParam_Style={{marginTop: 0}}
                                        inputParam_ShowLoading={true}
                                        inputParam_ShowText={true}
                                        inputParam_Text={t('data-lang-lbl-executing')}
                                        inputParam_Position="unset"
                                        inputParam_Width="20px"
                                        inputParam_Height="20px"
                                        inputParam_Vertical={false}
                                        inputParam_ColClassName="my-auto"
                                        inputParam_EjecutingTextClass={"ps-4"}
                                        inputParam_Left="87%"
                                        inputParam_Top="11px"
                                        inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                                    />
                                }
                                <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                            </div>
                        </Col>
                    </Row>
        }
    };
    const manipulateList = (list) => {
        if (list.filter(x => x.key === -1).length === 0) {
            list.unshift({key: -1, text: t('data-lang-lbl-select')})
        }

        return list;
    };
    const onChangeDistributionGruop = (ev, item) => {
        const currentObject = distributionGroupList.find(x => x.id === item.key);
        setSelectedDistributionGroup(!isNullUndefined(currentObject) ? (item.key === -1 ? null : currentObject) : null);
        setFireDistributionGroupSearch(true);
    };
    const onNotificationPivotChange = (item) => {
        const key = item.props.itemKey; // o item?.props.headerText
        if (key) setNotificationPivotItemActive(key);
        setDocumentMessageList(prevState => ({
            ...prevState,
            fireUpdate: true
        }));
    };
    const onChangePrincipalUserSelectedOption = (ev, option) => {
        distributionGroupUsersList.forEach(element => {
            if (element.id === option.key) {
                element.principal = true;
                element.text = `${element.fullName} (${t('data-lang-lbl-principal')})`
            }
            else {
                element.principal = false;
                element.text = `${element.fullName} (${t('data-lang-lbl-cc')})`
            }
        });

        setDistributionGroupUsersList && setDistributionGroupUsersList(distributionGroupUsersList);
    };

    const getComponentContent = () => {
        return <>
                <fieldset disabled={ (inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate) ? false : true}>
                    <Row className="pt-3">
                        <Col xl={6}>
                            <CTextBox editMode={ false } controlValue={ objMensaje && objMensaje.item_message.messageCode } setterControlValue={ setMessageCode } isInValid={txtCodeIsInValid} textBoxName="code" labelText={ t('data-lang-lbl-code') } />
                        </Col>
                    </Row>
                    {
                        inputParam_NotificationMode === false &&
                        <>
                            <Row className="pt-3">
                                {
                                    (inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate) &&
                                    <Col>
                                        {
                                            sectionList &&
                                            <Picker
                                                data={ sectionList !== null ? sectionList : [] }
                                                mode="simpleSelect"
                                                className="dropdown-checkbox"
                                                isInValid={ isInvalidSection }
                                                texts={{ placeholder: t('data-lang-lbl-choose') }}
                                                onChange={ onChangeSection }
                                                labelText={ t('data-lang-lbl-candidatesections') }
                                                refresh={true}
                                                disabled={!editMode}
                                            />
                                        }
                                        <CValidator isInValid={ isInvalidSection } />
                                    </Col>
                                }
                                {
                                    (inputParam_MessageObject.deactivate !== null && inputParam_MessageObject.deactivate) &&
                                    <Col>
                                        <CTextBox editMode={ false } controlValue={ sectionList !== null ? sectionList.filter(x => x.checked).map(x => x.label).join(",") : "" } setterControlValue={ null } labelText={ t('data-lang-lbl-candidatesections') } />
                                    </Col>
                                }
                            </Row>
                            <Row className="pt-3">
                                {
                                    (inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate) &&
                                    <Col>
                                        <Picker
                                            data={ sectionPartyList !== null ? sectionPartyList : [] }
                                            mode="multiSelect"
                                            className="dropdown-checkbox"
                                            isInValid={ isInvalidSectionParty }
                                            texts={{ placeholder: t('data-lang-lbl-choose') }}
                                            onChange={ onChangeSectionParty }
                                            labelText={ t('data-lang-lbl-candidatepartys') }
                                            refresh={true}
                                            disabled={!editMode}
                                        />
                                        <CValidator isInValid={ isInvalidSectionParty } />
                                    </Col>
                                }
                                {
                                    (inputParam_MessageObject.deactivate !== null && inputParam_MessageObject.deactivate) &&
                                    <Col>
                                        <CTextBox editMode={ false } controlValue={ sectionPartyList !== null ? sectionPartyList.filter(x => x.checked).map(x => x.label).join(",") : "" } setterControlValue={ null } labelText={ t('data-lang-lbl-candidatepartys') } />
                                    </Col>
                                }
                            </Row>
                        </>
                    }
                    {
                        inputParam_NotificationMode === true &&
                        <>
                            <Row className="pt-3">
                                <Col>
                                    <CTextBox editMode={ false } controlValue={ sectionList !== null ? sectionList.filter(x => x.checked).map(x => x.label).join(",") : "" } setterControlValue={ null } labelText={ t('data-lang-lbl-candidatesections') } />
                                </Col>
                            </Row>
                            <Row className="pt-3">
                                <Col>
                                    <CTextBox editMode={ false } controlValue={ sectionPartyList !== null ? sectionPartyList.filter(x => x.checked).map(x => x.label).join(",") : "" } setterControlValue={ null } labelText={ t('data-lang-lbl-candidatepartys') } />
                                </Col>
                            </Row>
                        </>
                    }
                    <Row>
                        <Col>
                            <Picker
                                data={ topicList !== null ? topicList : [] }
                                mode="simpleSelect"
                                className="dropdown-checkbox"
                                isInValid={ isInvalidTemplateSection }
                                texts={{ placeholder: t('data-lang-lbl-choose') }}
                                onChange={ onChangeTemplateSection }
                                labelText={ t('data-lang-lbl-topic') }
                                refresh={true}
                            />
                            <CValidator isInValid={ isInvalidTemplateSection } />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="pt-3" xs={12} sm={12} md={12} lg={12} xl={12}>
                            <CTextBox editMode={ editMode } controlValue={ objMensaje && objMensaje.item_message.title } setterControlValue={ setMessageTitle } isInValid={txtNameIsInValid} textBoxName="name" labelText={ t('data-lang-lbl-title') } />
                        </Col>
                        <Col className="pt-3" xs={12} sm={6} md={6} lg={6} xl={6}>
                            <Toggle
                                label={ t('data-lang-lbl-requiresanswer') }
                                checked={ objMensaje && objMensaje.item_message.answerNeeded }
                                onChange={ onChangeRequiresAnswer }
                                role="checkbox"
                                onText={ t('data-lang-btn-yes') }
                                className="pt-4 float-start"
                                offText={ t('data-lang-btn-no') }
                                disabled={ editMode ? ((inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate) ? false : true) : true }
                                styles={ { container:{ paddingTop: "4px" }, root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                            />
                        </Col>
                        {
                            objMensaje &&
                            <Col className="pt-3" xs={12} sm={3} md={3} lg={3} xl={3}>
                                <Toggle
                                    label={ t('data-lang-lbl-endorse') }
                                    checked={ objMensaje ? (objMensaje.item_message.visa === null ? false : objMensaje.item_message.visa >= 0) : false }
                                    onChange={ onChangeVisa }
                                    role="checkbox"
                                    onText={ t('data-lang-btn-yes') }
                                    className="pt-4 float-start"
                                    offText={ t('data-lang-btn-no') }
                                    styles={ { container:{ paddingTop: "4px" }, root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                    disabled={
                                        ((editMode === true) || visibilityButtonSend(inputParam_MessageObject.id, inputParam_MessageObject !== null ? inputParam_MessageObject.statusId : 0, inputParam_UserProps, inputParam_BookObject !== null ? inputParam_BookObject.requiresApproval : null, false, inputParam_MessageObject.visa === 1 || (inputParam_MessageObject.visa === 3 || objMensaje.item_message.visa === 3)) === false) ?
                                        !(objMensaje.item_message.statusId === enum__MessageStatus.ONAPROBATION) : !((editMode === true) || visibilityButtonSend(inputParam_MessageObject.id, inputParam_MessageObject !== null ? inputParam_MessageObject.statusId : 0, inputParam_UserProps, inputParam_BookObject !== null ? inputParam_BookObject.requiresApproval : null, false, inputParam_MessageObject.visa === 1 || (inputParam_MessageObject.visa === 3 || objMensaje.item_message.visa === 3)) === false)
                                    }
                                />
                            </Col>
                        }
                        <Col className="pt-3" xs={12} sm={6} md={6} lg={6} xl={6}>
                        {
                            objMensaje && (objMensaje.item_message.answerNeeded && (objMensaje.item_message.visa === null || objMensaje.item_message.visa === 1 || objMensaje.item_message.visa === 3)) && !inputParam_NotificationMode &&
                            <CDatePicker
                                controlValue={ objMensaje && objMensaje.item_message.answerDeadlineDate }
                                setterControlValue={ setMessageAnswerDeadlineDate }
                                isInValid={ pickerAnswerDeadlineDateIsInValid } 
                                labelText={ t('data-lang-lbl-answerdeadlinedate') }
                                disabled={ editMode ? ((inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate) ? false : true) : (objMensaje.item_message.visa === 1 || objMensaje.item_message.visa === 3 ? false : true) }
                            />
                        }
                        </Col>
                        {
                            !isNullUndefined(distributionGroupList) && !isNullUndefined(objMensaje) && !isNullUndefined(objMensaje.item_message.visa) && objMensaje.item_message.visa >= 0 &&
                            <>
                                {
                                    inputParam_MessageObject.statusId !== enum__MessageStatus.TOVISA && inputParam_MessageObject.statusId !== enum__MessageStatus.SENDED &&
                                    <Col xl={12}>
                                        <CLabel labelText={ t('data-lang-lbl-distributiongroup') } /><br/>
                                        <Dropdown
                                            placeholder={t('data-lang-btn-select')}
                                            options={manipulateList(distributionGroupList.map(x => {return {key: x.id, text: x.name}}))}
                                            selectedKey={!isNullUndefined(selectedDistributionGroup) ? selectedDistributionGroup.id : undefined}
                                            onChange={(event, option) => onChangeDistributionGruop(event, option)}
                                            checkable
                                            disabled={!inputParam_MessageObject.statusId === enum__MessageStatus.ONAPROBATION || inputParam_MessageObject.statusId === enum__MessageStatus.TOVISA}
                                            styles={ {title: { height: "27px" }} }
                                            className="mb-1 w-100"
                                        />
                                        <CValidator isInValid={isInvalidDistributionGroupList} inValidText={` ${t('data-lang-msg-required')}`} />
                                    </Col>
                                }
                                {
                                    !isNullUndefined(distributionGroupUsersList) &&
                                    <Col xl={12}>
                                        <Card className='mt-3'>
                                            <Card.Body className='border-bottom py-1 px-2'>
                                                <b>{t('data-lang-lbl-users')}</b>
                                            </Card.Body>
                                            <Card.Body className='py-0 pt-0 pb-2 m-0' id="choice-field-book-panel-edit">
                                                <ChoiceGroup
                                                    selectedKey={!isNullUndefined(distributionGroupUsersList.find(x => x.principal === true)) ? distributionGroupUsersList.find(x => x.principal === true).key : undefined}
                                                    options={distributionGroupUsersList}
                                                    onChange={onChangePrincipalUserSelectedOption}
                                                    disabled={!inputParam_MessageObject.statusId === enum__MessageStatus.ONAPROBATION || inputParam_MessageObject.statusId === enum__MessageStatus.TOVISA}
                                                    styles={{ field: { width: "100%" } }}
                                                />
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                }
                            </>
                        }
                        <Col className="pt-3" xl={12}>
                            {
                                objMensaje && objMensaje.item_message &&
                                <>
                                {
                                    editMode === true ?
                                    <>
                                        {
                                            (inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate) && isTemplatePanelOpen !== true &&
                                            <CTextArea
                                                labelText={ t('data-lang-lbl-body') }
                                                controlValue={ objMensaje && objMensaje.item_message.body }
                                                setterControlValue={ setMessageBody }
                                                isInvalirControl={ txtBodyIsInValid }
                                                hideToolbarOptions={[
                                                    'link',
                                                    'unlink',
                                                    'image',
                                                    'remove'
                                                ]}
                                            />                            
                                        }
                                        {
                                            (inputParam_MessageObject.deactivate !== null && inputParam_MessageObject.deactivate) &&
                                            <>
                                            <CTextAreaSimple labelText={t('data-lang-lbl-body')} controlValue={ objMensaje && objMensaje.item_message.body } setterControlValue={null} isInvalirControl={false} editMode={false} />
                                            <br></br>
                                            </>
                                        }
                                    </> :
                                    <CTextAreaSimple
                                        labelText={ t('data-lang-lbl-body') }
                                        controlValue={ objMensaje && objMensaje.item_message.body }
                                        setterControlValue={ null }
                                        isInvalirControl={ false }
                                        editMode={false}
                                        hideToolbarOptions={[
                                            'link',
                                            'unlink',
                                            'image',
                                            'remove'
                                        ]}
                                    />                            
                                }
                                </>
                            }
                        </Col>
                    </Row>

                    <Row className="pt-3">
                        <Col className='text-end' xl={12}>
                        {
                            (editMode || (inputParam_NotificationTask && (inputParam_NotificationTask.completed === false || inputParam_NotificationTask.completed === null) && inputParam_MessageObject.visa === null && inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate)) &&
                            <ActionButton onClick={() => setIsModalDocumentOpen(true)} iconProps={{ iconName: 'OpenFile' }} allowDisabledFocus disabled={false&&documentUploadDisabled}>
                                {t('data-lang-btn-documentlilnk')}
                            </ActionButton>
                        }
                        <ActionButton onClick={() => setIsTemplatePanelOpen(true)} iconProps={{ iconName: 'WebTemplate' }} allowDisabledFocus disabled={false&&documentUploadDisabled}>
                            {t('data-lang-btn-usemessagetemplate')}
                        </ActionButton>
                        </Col>
                        <Col xl={12} ref={targetRef}>
                            <List
                                listLocalStoragePageSizeVariableName="messageBoxEditPanelDocuments"
                                className="no-compact-list big-header"
                                manipulateLocalData={ true }
                                setData={setDocumentMessageList}
                                data={documentMessageList}
                                key={'listDocuments'}
                                columns={[
                                    {  
                                        key: 'extension',
                                        name: t('data-lang-lbl-type'),
                                        fieldName: 'extension',
                                        minWidth: 40,
                                        maxWidth: 40,
                                        onRender:(item) => {
                                            return getKeyByValue(__DocumentTypeKeys, item.extension)
                                        }
                                    },
                                    {
                                        key: "documentCode",
                                        name: t('data-lang-lbl-code'),
                                        fieldName: "documentCode",
                                        minWidth: 50,
                                        maxWidth: 100,
                                        isResizable: true
                                    },
                                    {
                                        key: "name",
                                        name: t('data-lang-lbl-name'),
                                        fieldName: "name",
                                        minWidth: 100,
                                        maxWidth: 200,
                                        isResizable: true
                                    },
                                    {  
                                        key: 'id',
                                        name: t('data-lang-lbl-actions'),
                                        fieldName: 'id',
                                        //minWidth: "10%",
                                        //maxWidth: "10%",
                                        onRender:(item, row) => {
                                            return  <div>
                                                        {
                                                            (inputParam_NotificationMode === false ? (inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate) : editMode) &&
                                                            <OverflowSet
                                                                className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                                role="menubar"
                                                                items={[
                                                                    {
                                                                        key: 'item1',
                                                                        icon: 'Delete',
                                                                        name: t('data-lang-btn-delete'),
                                                                        title: t('data-lang-btn-delete'),
                                                                        onClick: () => onDeleteDocumentFromListClick(item, setItemToDelete),
                                                                    },
                                                                    {
                                                                        key: 'download',
                                                                        icon: 'CloudDownload',
                                                                        name: t('data-lang-btn-download'),
                                                                        title: t('data-lang-btn-download'),
                                                                        onClick: () => onDownloadDocumentsByIds([item.id], item.name),
                                                                    }
                                                                ].filter(x => editMode ? true : x.key !== 'item1')}
                                                                onRenderOverflowButton={__onRenderOverflowButton}
                                                                onRenderItem={__onRenderOverflowItem}
                                                            />
                                                        }
                                                        {
                                                            //(inputParam_MessageObject.deactivate !== null && inputParam_MessageObject.deactivate) &&
                                                            inputParam_NotificationMode === true && (inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate) && !editMode &&
                                                            <OverflowSet
                                                                className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                                role="menubar"
                                                                items={[
                                                                    {
                                                                        key: 'download',
                                                                        icon: 'CloudDownload',
                                                                        name: t('data-lang-btn-download'),
                                                                        title: t('data-lang-btn-download'),
                                                                        onClick: () => onDownloadDocumentsByIds([item.id], item.name),
                                                                    }
                                                                ]}
                                                                onRenderOverflowButton={__onRenderOverflowButton}
                                                                onRenderItem={__onRenderOverflowItem}
                                                            />
                                                        }
                                                    </div>
                                        }
                                    }  
                                ]}
                                inputParam_Styles={{
                                    root: { minHeight: 200 }
                                }}
                            />
                        </Col>
                    </Row>
                </fieldset>
                {
                    isModalDocumentOpen === true &&
                    <DocumentLinkModal
                        bookObject={inputParam_BookObject}
                        isModalOpen={ isModalDocumentOpen }
                        setIsModalOpen={setIsModalDocumentOpen}
                        setterSelectedDocumentToLink={ setAditionalDocumentMessageList }
                        userProps={inputParam_UserProps}
                    />
                }
                {
                    //[##CODELCO-CARD-4-##] Plantillas de Comunicación
                    //Al crear la nueva comunicación se abre el panel lateral derecha (flujo actual)
                    isTemplatePanelOpen === true && objMensaje !== null && topicList &&
                    <SidePanelCreateWithTemplate
                        isPanelOpen={isTemplatePanelOpen}
                        setterIsPanelOpen={setIsTemplatePanelOpen}
                        objMessage={objMensaje}
                        topicList={topicList}
                        setTopicList={setTopicList}
                        setterObjMessage={setObjMensaje}
                    />
                }
        </>
    };

    const onSetNotificationComment = (obj) => {
        setNotificationComment(obj.currentTarget.value);
    };

    const onViewComment = (obj) => {
        setObjCommentToPanel(obj);
        setIsPanelObjCommentOpen(true);
    };

    const actionCellsRenderer = (itemId) => {
        const rowData = notificationCommentList.find(x => x.id === itemId);
    
        return (
        <div>
            <OverflowSet
                className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                role="menubar"
                items={[
                    {
                        key: "view",
                        icon: "View",
                        name: t("data-lang-btn-view"),
                        title: t("data-lang-btn-view"),
                        onClick: () => onViewComment(rowData),
                    },
                ]}
                onRenderOverflowButton={__onRenderOverflowButton}
                onRenderItem={__onRenderOverflowItem}
            />
        </div>
        );
    };

    if (itemToDelete !== null) { 
        if (objMensaje.id === null) {
            setDocumentMessageList(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: documentMessageList.data.filter(x => x.id !== itemToDelete.id)
            }));

            setShowMessage(true)
            setMessageType("success");
            setMessage(t('data-lang-msg-operationperformed'))
        }
        else {
            if ((objMensaje.item_message.visa === 3 && inputParam_MessageObject.visa !== 3)) {
                setDocumentMessageList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: documentMessageList.data.filter(x => x.id !== itemToDelete.id)
                }));

                setDocumentsToDeleteAfterBreakVisaSave(documentsToDeleteAfterBreakVisaSave.push(itemToDelete))

                setShowMessage(true)
                setMessageType("success");
                setMessage(t('data-lang-msg-operationperformed'))
            }
            else {
                removeDocumentByMessageDocument(itemToDelete.id, objMensaje.id).then((response) => {
                    if(response.data.succeeded) {

                        setDocumentMessageList(prevState => ({
                            ...prevState,
                            fireUpdate: true,
                            data: documentMessageList.data.filter(x => x.id !== itemToDelete.id)
                        }));
            
                        setShowMessage(true)
                        setMessageType("success");
                        setMessage(t('data-lang-msg-operationperformed'))
                    }
                    else {
                        setShowMessage(true)
                        setMessageType("error");
                        setMessage(t('data-lang-msg-operationerror'))
                    }
                }).catch(() => {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                });
            }
        }
        setItemToDelete(null);
    }

    // Recalcula el scroller cuando el panel se abre
    useEffect(() => {
        if (!inputParam_IsPanelOpen) {
        setScrollRoot(null);
        return;
        }

        let cancelled = false;

        // Espera a que el Panel exista en el DOM (por portal + animación)
        const tryResolve = () => {
        const scroller = findPanelScroller("left-panel");
        if (scroller) {
            if (!cancelled) setScrollRoot(scroller);
            return true;
        }
        return false;
        };

        // Intento inmediato + reintentos cortos (típicamente basta con 1–3)
        if (tryResolve()) return;

        const id = setInterval(() => {
        if (tryResolve()) clearInterval(id);
        }, 50);

        // corta el polling luego de un tiempo razonable
        const timeout = setTimeout(() => clearInterval(id), 2000);

        return () => {
        cancelled = true;
        clearInterval(id);
        clearTimeout(timeout);
        };
    }, [inputParam_IsPanelOpen]);

    const isInView = useInView(targetRef, {
        root: scrollRoot,
        threshold: 0.01,
        rootMargin: "0px 0px -185px 0px" // top right bottom left
    });

    const debeBloquearControles = (listado, variable, nombrePropiedad = "texto") => {
        const numeroEsperado = variable == null ? 1 : variable + 1;

        return listado.some(x => {
            const valor = x[nombrePropiedad];
            if (typeof valor !== "string") return false;

            const match = valor.match(/#(\d+)$/);
            if (match === null && variable >= 0) {
                return true
            }

            return Number(match[1]) === numeroEsperado;
        });
    }

    //Render de componente.
    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isOnRightSide={false}
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ inputParam_NotificationMode === false ? t('data-lang-lbl-editmessage') : t('data-lang-boxname-aditionalinfo') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                type={PanelType.customNear}
                customWidth="60vw"
                className="left-panel"
            >
                {
                    inputParam_NotificationMode === true && inputParam_ShowNotificationTask &&
                    <>
                        <Row>              
                            <Col className='p-0 m-0'>              
                                <NotificationTasksCard
                                    inputParam_ShowMinimized={true}
                                    inputParam_ObjItem={inputParam_NotificationTask}
                                    inputParam_HandlerOnClickNotificationTaskRow={null}
                                    inputParam_FieldActionHandler={null}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div name="textarea" rows="4" className='w-100 border' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(inputParam_NotificationTask.description, { USE_PROFILES: { html: true } }) }}></div>
                            </Col>
                        </Row>
                    </>
                }
                {
                    inputParam_NotificationMode === true &&
                    <>
                        {
                            (inputParam_ParentEditMode === true || inputParam_ForceShowComment === true) &&
                            <Pivot selectedKey={notificationPivotItemActive} onLinkClick={onNotificationPivotChange}>
                                <PivotItem itemKey={'0'} headerText={ (inputParam_ParentEditMode === true || inputParam_ForceShowComment === true) ? 'Mensaje a visar' : undefined }>
                                    { getComponentContent() }
                                </PivotItem>
                                {
                                    (inputParam_ParentEditMode === true || inputParam_ForceShowComment === true) &&
                                    <PivotItem itemKey={'1'} headerText={ 'Comentario de visación' }>
                                        {
                                            notificationCommentList && editMode &&
                                            <>
                                                <CTextAreaSimple editMode={editMode && !debeBloquearControles(notificationCommentList, notificationCommentList.length, 'messageEventName')} labelText={ t('data-lang-lbl-comment') } controlValue={ notificationComment } setterControlValue={ onSetNotificationComment } setterControlIsDynamic={false} />
                                                <CValidator isInValid={ (notificationComment.trim() === "" || isInvalidVisaRejectedComment === true) && !debeBloquearControles(notificationCommentList, notificationCommentList.length, 'messageEventName') } />
                                                {
                                                    !hideActionButtons && (inputParam_MessageObject.deactivate !== null && !inputParam_MessageObject.deactivate) &&
                                                    <>
                                                        {
                                                            !actionInProgress && !debeBloquearControles(notificationCommentList, notificationCommentList.length, 'messageEventName') && editMode && notificationPivotItemActive === '1' && (inputParam_ParentEditMode === true && inputParam_ForceShowComment === false) &&
                                                            <>
                                                                <PrimaryButton onClick={ () => onSaveNotificationComment() } styles={_global_buttonStyles}>{ t('data-lang-btn-save-comment') }</PrimaryButton>
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </>
                                        }
                                        {
                                            objCommentToPanel && isPanelObjCommentOpen &&
                                            <SidePanelViewCommentEvent
                                                messageEventObject={ objCommentToPanel }
                                                isPanelOpen={ isPanelObjCommentOpen }
                                                setterIsPanelOpen={ setIsPanelObjCommentOpen }
                                            />  
                                        }
                                        <Row className='pt-3'>
                                            <Col xl={12}>
                                                <b><label class="pe-2 form-label">Comentarios previos del mensaje:</label></b>
                                            </Col>
                                            <Col xl={12}>
                                            {
                                                notificationCommentList && notificationPivotItemActive === '1' &&
                                                <div style={{ height: "40vh" }}>

                                                <JqxGrid
                                                    useRef={gridRef}
                                                    width={"100%"}
                                                    columns={[
                                                        { text: t("data-lang-lbl-date"), datafield: "messageEventDate", width: "20%", cellsformat: "dd/MM/yyyy", columntype: "datetimeinput" },
                                                        { text: t("data-lang-lbl-comment"), datafield: "messageEventDesc", width: "40%" },
                                                        { text: t("data-lang-lbl-creationusername"), datafield: "messageEventFullname", width: "30%" },
                                                        {
                                                            text: t("data-lang-lbl-actions"),
                                                            datafield: "id",
                                                            width: "10%",
                                                            createwidget: (row, column, value, htmlElement) => {
                                                            ReactDOM.render(actionCellsRenderer(value), htmlElement);
                                                            },
                                                            initwidget: (row, column, value, htmlElement) => {
                                                            ReactDOM.render(actionCellsRenderer(value), htmlElement);
                                                            },
                                                        },
                                                    ]}
                                                    pageable={false}
                                                    autoheight={false}
                                                    height={"100%"}
                                                    altrows={true}
                                                    columnsresize={true}
                                                    source={
                                                        new window.jqx.dataAdapter({
                                                            localdata: notificationCommentList || [],
                                                            datatype: "array",
                                                            id: "id",
                                                            datafields: [
                                                                { name: "id", type: "number" },
                                                                { name: "messageEventDate", type: "date" },
                                                                { name: "messageEventDesc", type: "string" },
                                                                { name: "messageEventFullname", type: "string" },
                                                            ],
                                                        })
                                                    }
                                                />
                                            </div> 
                                            }
                                            </Col>
                                        </Row>
                                    
                                    </PivotItem>
                                }
                            </Pivot>
                        }
                        {
                            (inputParam_ParentEditMode === false && inputParam_ForceShowComment === false) && getComponentContent()
                        }
                    </>
                }
                {
                    (inputParam_NotificationMode === false && inputParam_ForceShowComment === false) &&
                    getComponentContent()
                }
                <Dialog
                    hidden={!isDialogDeleteMessageVisible}
                    onDismiss={onHideDeleteMessageDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-delete-message'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onDeleteMessage} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDeleteMessageDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
                <Dialog
                    hidden={!isDialogBreakVisaMessageVisible}
                    onDismiss={onHideBreakVisaMessageDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-boxname-warning'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 650 } },
                    }}
                    >
                        <div>Está a punto de romper el sello de visación realizado por el usuario{ distributionGroupUsersList && !isNullUndefined(distributionGroupUsersList.find(x => x.principal === true)) && distributionGroupUsersList.find(x => x.principal === true).fullname }.</div>
                        <div>¿Está seguro que desea realizar esta acción?.</div>
                    <DialogFooter>
                        <PrimaryButton onClick={() => onActionOpenVisa(3)} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideBreakVisaMessageDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
            <Dialog
                hidden={!isDialogVisible}
                onDismiss={onHideDialog}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: t('data-lang-msg-close-panel'),
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } },
                }}
                >
                <DialogFooter>
                    <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                    <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                </DialogFooter>
            </Dialog>
        </div>
    );
}

export default SidePanelEdit;